import { fetch } from "../lib/network";
import decamelizeKeysDeep from "decamelize-keys-deep";
import AppSettings from "../config";

export const getPermitsCustomFields = (networkHeaders: any) => () =>
  fetch(`${AppSettings.PERMITS_API_URL}/custom-fields`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getPermitsCustomField = (networkHeaders: any) => (key: any, id: string) =>
  fetch(`${AppSettings.PERMITS_API_URL}/custom-fields/${id}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putPermitsCustomField = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.PERMITS_API_URL}/custom-fields/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });

export const postPermitsCustomField = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PERMITS_API_URL}/custom-fields`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  }).then(async (res) => {
    if (res.ok) return res;
    const err = await res.json();
    throw new Error(err.error);
  });

export const deletePermitsCustomField = (networkHeaders: any, id: any) => (body: any) =>
  fetch(`${AppSettings.PERMITS_API_URL}/custom-fields/${id}`, {
    method: "DELETE",
    headers: networkHeaders,
    body: JSON.stringify(decamelizeKeysDeep({ data: { attributes: body } }, "-")),
  });
